import React, { useRef } from 'react';

interface Props {
    videoUrl: string;
    type: string;
    className?: string;
    poster?: string;
    onTimeUpdate?: React.ReactEventHandler<HTMLVideoElement>;
    onEnded?: React.ReactEventHandler<HTMLVideoElement>;
    onLoadedMetadata?: React.ReactEventHandler<HTMLVideoElement>;
    /** Fired when media starts or resumes rendering frames. */
    onPlaying?: React.ReactEventHandler<HTMLVideoElement>;
    /** Fired when playback stalls waiting for more data. */
    onWaiting?: React.ReactEventHandler<HTMLVideoElement>;
    /** Fired when the browser reports a media playback error. */
    onError?: React.ReactEventHandler<HTMLVideoElement>;
    /** Fired when the user or resume logic starts a seek. */
    onSeeking?: React.ReactEventHandler<HTMLVideoElement>;
    /** Fired when a seek completes and playback can continue from the new position. */
    onSeeked?: React.ReactEventHandler<HTMLVideoElement>;
    onPlay?: React.ReactEventHandler<HTMLVideoElement>;
    onPause?: React.ReactEventHandler<HTMLVideoElement>;
}

const VideoPlayer = (props: Props) => {
    const videoRef = useRef<HTMLVideoElement>(null);

    return (
        <video
            className={props.className}
            ref={videoRef}
            poster={props.poster}
            controls
            controlsList='nodownload'
            playsInline
            onTimeUpdate={props.onTimeUpdate}
            onEnded={props.onEnded}
            onLoadedMetadata={props.onLoadedMetadata}
            onPlaying={props.onPlaying}
            onWaiting={props.onWaiting}
            onError={props.onError}
            onSeeking={props.onSeeking}
            onSeeked={props.onSeeked}
            onPlay={props.onPlay}
            onPause={props.onPause}
            preload="metadata"
        >
            <source src={props.videoUrl} type={props.type} />
            Your browser does not support the video player.
        </video>
    );
};

export default VideoPlayer;
